/** The email belongs to another account. Shown under the email field rather than as a toast. */
export class EmailInUseError extends Error {
  constructor() {
    super('This email is already linked to another account. Try a different email.');
    this.name = 'EmailInUseError';
  }
}

/**
 * Maps a failed `/customer/update-info` save to what the contact step shows. The backend rejects an
 * email owned by another user with "Another user already has this email: Some(…)", which isn't
 * customer-facing copy. Anything else passes through unchanged.
 */
export function toContactSaveError(error: unknown): unknown {
  if (error instanceof Error && /already has this email/i.test(error.message)) {
    return new EmailInUseError();
  }
  return error;
}

/** Why a contact save failed, for the step's SaveFailed analytics event. */
export type ContactSaveFailureReason = 'emailInUse' | 'other';

export function contactSaveFailureReason(error: unknown): ContactSaveFailureReason {
  return error instanceof EmailInUseError ? 'emailInUse' : 'other';
}
